import { Button, Grid, TextField, FormControl, Select, InputLabel, MenuItem, FormControlLabel, Checkbox, InputAdornment } from "@mui/material";
import { useEffect, useState } from "react";
// import { toast } from "react-toastify";
import Autogooglecomplete from "./Autogooglecomplete";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LoadingOverlay from "../mui/LoadingOverlay";
import {

  selectnodess,

} from "../redux/nodesSlice";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DeleteIcon from "@mui/icons-material/Delete";
import { selectgroups } from "../redux/businessSlice";
import { currencydata } from "../utils/currency";
import { NumericFormat } from "react-number-format";
import { useCreateOrganizationMutation } from "../redux/organizationApi";
export function RootOrgForm() {
  const { root } = useParams();
  const groups = useSelector(selectgroups);
  const navigate = useNavigate();
  const allorganization = useSelector(selectnodess) || [];
  const [parentOptions, setParentOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [createOrganization] = useCreateOrganizationMutation();

  const initialIds = {
    parentId: "",
    childId: "",
  };

  // //// console.log(allorganization)
  const [ids, setIds] = useState(initialIds);

  //// console.log("Param value:", root);


  useEffect(() => {
    const parents = Array.isArray(allorganization) && allorganization?.map((org) => {
      return {
        label: org.data.label,
        value: org.id.toString(),
      };
    });
    //// console.log(parents);
    setParentOptions(parents);
  }, [allorganization]);
  const handleRemarksChange = (value) => {
    setNodeData((prevData) => ({
      ...prevData,
      Remarks: value, // Update Remarks in state
    }));
  };



  const initialNode = {
    companyName: "",
    location: {
      name: "", address: "", lat: "", lng: "", countryName: ""
    },
    totalNoOfShares: "",
    directors: [""],
    shareHolders: [],
    BusinessNature: "",
    registerCurrency: '',
    Incorporationdate: "",
    CompanyRegistrationNumber: "",
    BusinessRegistrationNumber: "",
    ManagingDirector: "",
    DeputyManagingDirector: "",
    Chairman: "",
    ParValueofShares: "",
    AuthorizedCapital: "",
    ParCurrency: "",
    ResidentDirector: "",
    DeputyChairman: "",
    CompanySecretary: "",
    StatutoryAuditor: "",
    RepresentativeDirector: "",
    LegalRepresentative: "",
    TotalPaidUpCapital: "",
    isOperatingCompany: false,
    whollyCompany: false,
    Remarks: "",
    BusinessGroup: "",
  };
  const [nodeData, setNodeData] = useState(initialNode);
  const [errors, setErrors] = useState({
    general: {}, // For general fields
    shareholders: [], // For shareholders
    directors: [], // For directors
  });
  // const [addChildNodeData, setAddChildNodeData] = useState(initialNode);
  const requiredFields = [
    { key: "location", message: "Location is required" },
    { key: "companyName", message: "Company Name is required" },
    { key: "BusinessNature", message: "Business Nature is required" },
    { key: "Incorporationdate", message: "Incorporation date is required" },
    { key: "CompanyRegistrationNumber", message: "Company Registration Number is required" },
    // { key: "BusinessRegistrationNumber", message: "Business Registration Number is required" },
    // { key: "ManagingDirector", message: "Managing Director is required" },
    // { key: "DeputyManagingDirector", message: "Deputy Managing Director is required" },
    // { key: "Chairman", message: "Chairman is required" },
    // { key: "DeputyChairman", message: "Deputy Chairman is required" },
    // { key: "CompanySecretary", message: "Company Secretary is required" },
    // { key: "StatutoryAuditor", message: "Statutory Auditor is required" },
    // { key: "RepresentativeDirector", message: "Representative Director is required" },
    // { key: "LegalRepresentative", message: "Legal Representative Director is required" },
    // { key: "Remarks", message: "Remarks is required" },
    // { key: "TotalPaidUpCapital", message: "Total Paid Up Capital is required" },
    { key: "totalNoOfShares", message: "Total No of Shares is required" },
    { key: "BusinessGroup", message: "Business Group is required" },
  ];
  const handleChange = (e) => {
    // //// console.log("i am changed");
    const { name, value } = e.target;
    setNodeData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleAddDirector = () => {
    setNodeData((prev) => ({ ...prev, directors: [...prev.directors, ""] }));
  };
  const handelDirector = (index, name) => {
    const newNames = [...nodeData.directors];
    newNames[index] = name;
    setNodeData((prev) => ({ ...prev, directors: newNames }));
  };
  const handleShareHolders = (index, field, value) => {
    const updatedShareHolders = [...nodeData.shareHolders];
    updatedShareHolders[index] = {
      ...updatedShareHolders[index],
      [field]: value,
    };
    // Recalculate the percentage of shares
    if (field === "numberSharesOwned" && nodeData.totalNoOfShares > 0) {
      updatedShareHolders[index].PercentageOfShares =
        (value / nodeData.totalNoOfShares) * 100;
    }
    setNodeData((prev) => ({ ...prev, shareHolders: updatedShareHolders }));
  };
  const handleTotalSharesChange = (e) => {
    const { value } = e.target;
    const totalShares = parseFloat(value);
    // Update state and recalculate percentages
    setNodeData((pre) => ({ ...pre, totalNoOfShares: totalShares }));
  };
  const deleteDirectors = (index) => {
    setNodeData((prev) => ({
      ...prev,
      directors: prev.directors.filter((_, i) => i !== index)
    }));
  };

  const validateInput = () => {
    const errorObject = { general: {}, shareholders: [], directors: [] };

    requiredFields?.forEach((field) => {
      if (!nodeData[field.key] || (field.key === "location" && (
        !nodeData.location.name ||
        !nodeData.location.address ||
        nodeData.location.lat === null ||
        nodeData.location.lng === null
      ))) {
        errorObject.general[field.key] = field.message;
      }
    });


    // nodeData.directors?.forEach((director, index) => {
    //   if (!director) {
    //     errorObject.directors[index] = "Director Name is required";
    //   }
    // });
    setErrors(errorObject);
    return (
      Object.keys(errorObject.general).length === 0 &&
      errorObject.shareholders.every((e) => Object.keys(e).length === 0)
      // errorObject.directors.every((e) => !e)
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateInput()) {
      toast.error("Please fix the errors in the form.");
      return;
    }
    // //// console.log(nodeData);

    try {
      setLoading(true);
      await createOrganization({
        ...nodeData,
        isRoot: true,
      }).unwrap();
      toast.success(`Company added Successfully `);
      setNodeData(initialNode);
      navigate("/admin/UltimateHoldingCompany");
    } catch (error) {
      toast.error(
        error?.data?.message || error?.error || "failed to add Root Node"
      );
    } finally {
      setLoading(false);
    }
  };
  // //// console.log(nodeData.parentId);
  const handleCheckboxChange = (event) => {
    setNodeData({
      ...nodeData,
      isOperatingCompany: event.target.checked,
    });
  };

  return (
    <>
      <div className="pe-5 ps-1">
        <h2 className="text-center my-4">Add Company</h2>
        <Grid
          container
          spacing={2}
          className="border shadow "
          style={{
            backgroundColor: "#0057EB08",
          }}
          sx={{ maxWidth: 900, mx: "auto", p: 3, mt: 5 }}
          justifyContent="flex-end"
          // justifyContent="center"
          alignItems="left"
        >
          <Grid item xs={12} sm={6}>
            <TextField
              // label={root === "child" ? 'Shareholder Name' : "Company Name"}
              label="Company Name"
              name="companyName"
              id="outlined-basic"
              value={nodeData.companyName}
              onChange={handleChange}
              error={errors.general.companyName}
              fullWidth
              size="small"
              helperText={errors.general.companyName}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small" variant="outlined" error={Boolean(errors.general.BusinessNature)}>
              <InputLabel>Business Groups</InputLabel>
              <Select
                name="BusinessGroup"
                value={nodeData.BusinessGroup}
                onChange={handleChange}
                label="Business Groups"
              >
                {groups?.map((item, index) => {
                  return <MenuItem key={index} value={item._id}>{item?.businessNature?.charAt(0)?.toUpperCase() + item?.businessNature?.slice(1)}</MenuItem>
                })}

              </Select>
              {errors.general.BusinessGroup && <small style={{ color: 'red' }}>{errors.general.BusinessGroup}</small>}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>

            {/* <FormControl fullWidth size="small" variant="outlined" error={Boolean(errors.general.BusinessNature)}>
              <InputLabel>Business Nature</InputLabel>
              <Select
                name="BusinessNature"
                value={nodeData.BusinessNature}
                onChange={handleChange}
                label="Business Nature"
              >
                <MenuItem value="Corporate">Corporate</MenuItem>
                <MenuItem value="Automobile">Automobile</MenuItem>
                <MenuItem value="Financial Services">Financial Services</MenuItem>
                <MenuItem value="Machinery">Machinery</MenuItem>
                <MenuItem value="Property">Property</MenuItem>
                <MenuItem value="Trading">Trading</MenuItem>
              </Select>
              {errors.general.BusinessNature && <small style={{ color: 'red' }}>{errors.general.BusinessNature}</small>}
            </FormControl> */}

            <TextField
              // label={root === "child" ? 'Shareholder Name' : "Company Name"}
              label="Business Nature"
              name="BusinessNature"
              id="outlined-basic"
              value={nodeData.BusinessNature}
              onChange={handleChange}
              error={errors.general.BusinessNature}
              fullWidth
              size="small"
              helperText={errors.general.BusinessNature}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            {/* <TextField
              label="Location"
              variant="outlined"
              value={nodeData.location}
              name="location"
              onChange={handleChange}
              fullWidth
              error={errors.general.location}
              helperText={errors.general.location}
            /> */}
            <Autogooglecomplete setNodeData={setNodeData} errors={errors} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Incorporation Date"
              type="date"
              name="Incorporationdate"
              id="outlined-basic"
              value={nodeData.Incorporationdate}
              onChange={handleChange}
              error={Boolean(errors.general.Incorporationdate)}
              fullWidth
              helperText={errors.general.Incorporationdate}
              variant="outlined"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Managing Director"
              name="ManagingDirector"
              id="outlined-basic"
              value={nodeData.ManagingDirector}
              onChange={handleChange}
              error={Boolean(errors.general.ManagingDirector)}
              fullWidth
              helperText={errors.general.ManagingDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Company Registration Number"
              name="CompanyRegistrationNumber"
              id="outlined-basic"
              value={nodeData.CompanyRegistrationNumber}
              onChange={handleChange}
              error={Boolean(errors.general.CompanyRegistrationNumber)}
              fullWidth
              helperText={errors.general.CompanyRegistrationNumber}
              variant="outlined"
              size="small"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Deputy Managing Director"
              name="DeputyManagingDirector"
              id="outlined-basic"
              value={nodeData.DeputyManagingDirector}
              onChange={handleChange}
              error={Boolean(errors.general.DeputyManagingDirector)}
              fullWidth
              helperText={errors.general.DeputyManagingDirector}
              variant="outlined"
              size="small"
            />
          </Grid>


          <Grid item xs={12} sm={6}>
            <TextField
              label=" Business Registration Number"
              name="BusinessRegistrationNumber"
              id="outlined-basic"
              value={nodeData.BusinessRegistrationNumber}
              onChange={handleChange}
              error={Boolean(errors.general.BusinessRegistrationNumber)}
              fullWidth
              helperText={errors.general.BusinessRegistrationNumber}
              variant="outlined"
              size="small"
            />
          </Grid>


          <Grid item xs={12} sm={6}>
            <TextField
              label="Chairman"
              name="Chairman"
              id="outlined-basic"
              value={nodeData.Chairman}
              onChange={handleChange}
              error={Boolean(errors.general.Chairman)}
              fullWidth
              helperText={errors.general.Chairman}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.ParValueofShares}
              thousandSeparator
              customInput={TextField}
              label="Par Value of Shares"
              name="ParValueofShares"
              size="small"
              variant="outlined"
              fullWidth
              error={Boolean(errors.general.ParValueofShares)}
              helperText={errors.general.ParValueofShares}
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: 'ParValueofShares',
                    value: values.value
                  }
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TextField
                      select
                      name="ParCurrency"
                      onChange={handleChange}
                      variant="standard"
                      style={{ width: 70 }}
                    >
                      {currencydata?.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </InputAdornment>
                ),
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            // onBlur={handleSave} // Save on blur (optional)
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Deputy Chairman"
              name="DeputyChairman"
              id="outlined-basic"
              value={nodeData.DeputyChairman}
              onChange={handleChange}
              error={Boolean(errors.general.DeputyChairman)}
              fullWidth
              helperText={errors.general.DeputyChairman}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.TotalPaidUpCapital}
              thousandSeparator
              customInput={TextField}
              label="Registered/Issued Paid-up Capital"
              name="TotalPaidUpCapital"
              size="small"
              variant="outlined"
              fullWidth
              helperText={errors.general.TotalPaidUpCapital}
              error={Boolean(errors.general.TotalPaidUpCapital)}
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: 'TotalPaidUpCapital',
                    value: values.value
                  }
                });
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <TextField
                      select
                      variant="standard"
                      style={{ width: 70 }}
                      name="registerCurrency"
                      onChange={handleChange}

                    >
                      {currencydata?.map((currency) => (
                        <MenuItem key={currency} value={currency}>
                          {currency}
                        </MenuItem>
                      ))}
                    </TextField>
                  </InputAdornment>
                ),
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            // onBlur={handleSave} // Save on blur (optional)
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Company Secretary"
              name="CompanySecretary"
              id="outlined-basic"
              value={nodeData.CompanySecretary}
              onChange={handleChange}
              error={Boolean(errors.general.CompanySecretary)}
              fullWidth
              helperText={errors.general.CompanySecretary}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.totalNoOfShares}
              thousandSeparator
              customInput={TextField}
              label="Total Issued Shares"
              variant="outlined"
              name="totalNoOfShares"
              fullWidth
              error={errors.general.totalNoOfShares}
              helperText={errors.general.totalNoOfShares}
              size="small"
              onValueChange={(values) => {
                handleTotalSharesChange({
                  target: {
                    name: 'totalNoOfShares',
                    value: values.value
                  }
                });
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Statutory Auditor"
              name="StatutoryAuditor"
              id="outlined-basic"
              value={nodeData.StatutoryAuditor}
              onChange={handleChange}
              error={Boolean(errors.general.StatutoryAuditor)}
              fullWidth
              helperText={errors.general.StatutoryAuditor}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <NumericFormat
              value={nodeData.AuthorizedCapital}
              thousandSeparator
              customInput={TextField}
              label="Authorized Capital"
              name="AuthorizedCapital"
              id="outlined-basic"
              error={Boolean(errors.general.AuthorizedCapital)}
              fullWidth
              helperText={errors.general.AuthorizedCapital}
              variant="outlined"
              size="small"
              onValueChange={(values) => {
                handleChange({
                  target: {
                    name: 'AuthorizedCapital',
                    value: values.value
                  }
                });
              }}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 || floatValue === undefined;
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Representative Director"
              name="RepresentativeDirector"
              id="outlined-basic"
              value={nodeData.RepresentativeDirector}
              onChange={handleChange}
              error={Boolean(errors.general.RepresentativeDirector)}
              fullWidth
              helperText={errors.general.RepresentativeDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Resident Director"
              name="ResidentDirector"
              id="outlined-basic"
              value={nodeData.ResidentDirector}
              onChange={handleChange}
              error={Boolean(errors.general.ResidentDirector)}
              fullWidth
              helperText={errors.general.ResidentDirector}
              variant="outlined"
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Legal Representative"
              name="LegalRepresentative"
              id="outlined-basic"
              value={nodeData.LegalRepresentative}
              onChange={handleChange}
              error={Boolean(errors.general.LegalRepresentative)}
              fullWidth
              helperText={errors.general.LegalRepresentative}
              variant="outlined"
              size="small"
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            // key={index}
            sx={{ alignItems: "right" }}
          >
            {nodeData.directors?.map((dir, index) => (
              <div key={index} className="d-flex w-100 mb-2">
                <TextField
                  label="Director"
                  variant="outlined"
                  value={nodeData.directors[index]}
                  name="Director"
                  onChange={(e) => handelDirector(index, e.target.value)}
                  fullWidth
                  error={Boolean(errors.directors[index])}
                  helperText={errors.directors[index]}
                  size="small"
                />
                {index !== 0 && (
                  <DeleteIcon
                    style={{
                      fontSize: "30px",
                      color: "#1976d2",
                      cursor: "pointer",
                      marginLeft: "10px",
                      marginTop: "10px"
                    }}
                    onClick={() => deleteDirectors(index)}
                  />
                )}
              </div>))}
          </Grid>



          <Grid item xs={12} container className="d-flex justify-content-between" alignItems="center">
            {/* Checkbox for Operating Companies */}
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={nodeData.isOperatingCompany} // replace with your state variable
                    onChange={handleCheckboxChange} // replace with your change handler
                    name="isOperatingCompany"
                    color="primary"
                  />
                }
                label="Operating Company"
              />
            </Grid>

            {/* Add Director Button */}
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                endIcon={<AddIcon />}
                onClick={handleAddDirector}
              >
                Add Director
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12} container sx={{ mb: 8 }}>
            <ReactQuill
              value={nodeData.Remarks || ""} // Bind value to state, ensure it's a string
              onChange={handleRemarksChange} // Update state on change
              modules={{
                toolbar: [
                  // Headers and font size
                  [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }, { 'size': [] }],
                  // Text formatting
                  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                  // Lists and alignment
                  [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'align': [] }],
                  // Color and background color
                  [{ 'color': [] }, { 'background': [] }],
                  // Links, images, videos, and clear formatting
                  ['link', 'image', 'video'],
                  ['clean'] // Clear formatting
                ]
              }}

              placeholder="Enter remarks here..."
              style={{
                width: '100%', // Takes full width of the container
                height: '200px', // Custom height
              }}
            />
          </Grid>




          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleSubmit}
            >
              Save
            </Button>
          </Grid>
        </Grid>


      </div>
      <LoadingOverlay open={loading} />
    </>
  );
}
